import React from 'react';

const getLXPTypeTitle = isOneTime => {
  return isOneTime ? 'One-Time' : 'Multiday';
};

export default getLXPTypeTitle;
